import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BaseComponent } from "./views/layout/base/base.component";
import { AuthGuard } from "./core/guard/auth.guard";
import { ModuleGuard } from "./core/guard/module.guard";
import { ErrorPageComponent } from "./views/pages/error-page/error-page.component";
import { PasswordResetComponent } from "../app/views/pages/auth/password-reset/password-reset.component";
import { Modules } from "./core/model/modules.enum";
import { Privileges } from "./core/model/privileges.enum";
import { ViewRecepitComponent } from '../app/views/pages/transaction-management/view-recepit/view-recepit.component';
import { HostedConfigurationComponent } from "./views/pages/hosted-configuration/hosted-configuration.component";
import { ViewInvoiceComponent } from "./views/pages/virtual-terminal/view-invoice/view-invoice.component";
import { ViewReceiptNoAuthComponent } from "./views/pages/transaction-management/view-receipt-no-auth/view-receipt-no-auth.component";
import { MessageComponent } from "./views/pages/message/message.component";
import { TermsAndconditionComponent } from "./views/pages/terms-condition/terms-condition.component";

const routes: Routes = [
  {
    path: "terms-condition",
    component: TermsAndconditionComponent,
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./views/pages/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "view-recepit/:id/:type",
    component: ViewRecepitComponent,
  },
  {
    path: "view-receipt/:id/:type",
    component: ViewRecepitComponent,
  },
  {
    path: "cr/:id/:type",
    component: ViewReceiptNoAuthComponent,
  },

  {
    path: "vi/:id",
    component: ViewReceiptNoAuthComponent,
  },
  {
    path: "view-invoice/:id",
    component: ViewInvoiceComponent,
  },
  {
    path: "",
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
    // {
    //     path: "dashboard",
    //     loadChildren: () =>
    //       import("./views/pages/dashboard/dashboard.module").then(
    //         (m) => m.DashboardModule
    //       ),
    //   },
      {
        path: "dashboardv2",
        canActivate: [ModuleGuard],
        loadChildren: () =>
          import("./views/pages/dashboardv2/dashboardv2.module").then(
            (m) => m.Dashboardv2Module
          ),
        data: { module: Modules.DASHBOARD, privilege: Privileges.VIEW_DASHBOARD },
      }, 
      {
        path: "blink",
        canActivate: [ModuleGuard],
        loadChildren: () =>
          import("./views/pages/beta-search/beta-search.module").then(
            (m) => m.BetaSearchModule
          ),
        data: { module: Modules.BETA_SEARCH, privilege: Privileges.VIEW_BETA_SEARCH },
      }, 
      {
        path: "advanced-search",
        canActivate: [ModuleGuard],
        loadChildren: () =>
          import("./views/pages/advanced-search/advanced-search.module").then(
            (m) => m.BetaSearchModule
          ),
        data: { module: Modules.BETA_SEARCH, privilege: Privileges.VIEW_BETA_SEARCH },
      }, 
      {
        path: "beta-searchm2",
        canActivate: [ModuleGuard],
        loadChildren: () =>
          import("./views/pages/beta-searchm2/beta-searchm2.module").then(
            (m) => m.BetaSearchm2Module
          ),
        data: { module: Modules.DASHBOARD, privilege: Privileges.VIEW_DASHBOARD },
      }, 
      {
        path: "user-management",
        loadChildren: () =>
          import("./views/pages/user-management/user-management.module").then(
            (m) => m.UserManagementModule
          ),
        canActivate: [ModuleGuard],
        data: { module: Modules.USER, privilege: Privileges.VIEW_USER },
      },
      {
        path: "my-tickets",
        loadChildren: () =>
          import("./views/pages/my-tickets/my-tickets.module").then(
            (m) => m.MyTicketsModule
          ),
        canActivate: [ModuleGuard],
        data: { module: Modules.MY_TICKETS, privilege: Privileges.VIEW_TICKET },
      },
      {
        path: "customer-management",
        loadChildren: () =>
          import(
            "./views/pages/customer-management/customer-management.module"
          ).then((m) => m.CustomerManagementModule),
        canActivate: [ModuleGuard],
        data: { module: Modules.CUSTOMER, privilege: Privileges.VIEW_CUSTOMER },
      },
      {
        path: "isv-management",
        loadChildren: () =>
          import(
            "./views/pages/isv-management/isv-management.module"
          ).then((m) => m.IsvManagementModule),
        canActivate: [ModuleGuard],
        data: { module: Modules.ISV, privilege: Privileges.VIEW_ISV },
      },
      {
        path: "params-management",
        loadChildren: () =>
          import(
            "./views/pages/params-management/params-management.module"
          ).then((m) => m.ParamsManagementModule),
        canActivate: [ModuleGuard],
        data: { module: Modules.STEAM, privilege: Privileges.VIEW_DEVICE },
      },
      {
        path: "application-management",
        loadChildren: () =>
          import(
            "./views/pages/steam/steam.module"
          ).then((m) => m.SteamModule),
        // canActivate: [ModuleGuard],
        // data: { module: Modules.STEAM, privilege: Privileges.VIEW_APPLICATION },
      },
      {
        path: "steam-param",
        loadChildren: () =>
          import(
            "./views/pages/steam/steam.module"
          ).then((m) => m.SteamModule),
        // canActivate: [ModuleGuard],
        // data: { module: Modules.STEAM, privilege: Privileges.VIEW_APPLICATION },
      },
      {
        path: "manage-market-app",
        loadChildren: () =>
          import(
            "./views/pages/steam/market-management/market-management.module"
          ).then((m) => m.MarketManagementModule)
      },
      {
        path: "dv-store",
        loadChildren: () =>
          import(
            "./views/pages/steam/value-added-apps/value-added-apps.module"
          ).then((m) => m.ValueAddedAppsModule)
      },
      {
        path: "non-gateway-web",
        loadChildren: () =>
          import(
            "./views/pages/steam/steam.module"
          ).then((m) => m.SteamModule)
      },
      {
        path: "asset-management",
        loadChildren: () =>
          import(
            "./views/pages/steam/steam.module"
          ).then((m) => m.SteamModule),
      },
      {
        path: "downloadlog-management",
        loadChildren: () =>
          import(
            "./views/pages/steam/steam.module"
          ).then((m) => m.SteamModule),
      },
      {
        path: "virtual-terminal",
        loadChildren: () =>
          import(
            "./views/pages/virtual-terminal/virtual-terminal.module"
          ).then((m) => m.VirtualTerminalModule),
      },
      {
        path: "new-cloudpos",
        loadChildren: () =>
          import(
            "./views/pages/new-cloud-pos/cloud-pos.module"
          ).then((m) => m.CloudPosModule),
      },
      {
        path: "invoice",
        loadChildren: () =>
          import(
            "./views/pages/new-invoice/new-invoice.module"
          ).then((m) => m.NewInvoiceModule),
      },
      {
        path: "consumer-list",
        loadChildren: () =>
          import(
            "./views/pages/consumer-management/consumer-management.module"
          ).then((m) => m.ConsumerManagementModule),
      },
      {
        path: "device-alert-management",
        loadChildren: () =>
        import(
          "./views/pages/steam/steam.module"
        ).then((m) => m.SteamModule),
      },
      {
        path: "app-auditlog-list",
        loadChildren: () =>
        import(
          "./views/pages/auditlog-management/auditlog-management.module"
        ).then((m) => m.AuditlogManagementModule),
      },
      {
        path: "proxy-login-logs",
        loadChildren: () =>
          import(
            "./views/pages/proxy-login-logs-page/proxy-login-logs-page.module"
          ).then((m) => m.ProxyLoginLogsPageModule),
      },
      {
        path: "communication-center",
         loadChildren: () =>
          import(
            "./views/pages/steam/communication-center/communication-center.module"
          ).then((m) => m.CommunicationCenterModule)
      },
      {
        path: "promotions",
        loadChildren: () =>
          import(
            "./views/pages/promotions-page/promotions.module"
          ).then((m) => m.PromotionsModule),
        canActivate: [ModuleGuard],
        data: { module: Modules.PROMOTION, privilege: Privileges.VIEW_PROMOTION },
      },
      {
        path: "inventory",
        loadChildren: () =>
          import(
            "./views/pages/inventory-page/inventory.module"
          ).then((m) => m.InventoryModule),
        canActivate: [ModuleGuard],
        data: { module: Modules.INVENTORY, privilege: Privileges.VIEW_INVENTORY },

      },

      {
        path: "reports",
        loadChildren: () =>
          import(
            "./views/pages/reports/reports.module"
          ).then((m) => {  return m.ReportsModule }),
        canActivate: [ModuleGuard],
        data: { module: Modules.REPORTS },
      },
      {
        path: "digital-ads-on-screen",
        loadChildren: () =>
          import(
            "./views/pages/digital-ad-on-screen/digital-ad-on-screen.module"
          ).then((m) => m.DigitalAdOnScreenModule),
        canActivate: [ModuleGuard],
        data: { module: Modules.CAMPAIGN, privilege: Privileges.VIEW_CAMPAIGN },
      },
      {
        path: "risk-management",
        loadChildren: () =>
          import(
            "./views/pages/risk-management/risk-management.module"
          ).then((m) => m.RiskManagementModule),
         canActivate: [ModuleGuard],
        data: { module: Modules.RISK_MANAGEMENT, privilege: Privileges.VIEW_RISK_DETAILS },

      },
      {
        path: "transaction-management",
        loadChildren: () =>
          import(
            "./views/pages/transaction-management/transaction-management.module"
          ).then((m) => m.TransactionManagementModule),
      },
      {
        path: "merchant-management",
        loadChildren: () =>
          import(
            "./views/pages/merchant-management/merchant-management.module"
          ).then((m) => m.MerchantManagementModule)
      },
      {
        path: "merchant-settings",
        loadChildren: () =>
          import(
            "./views/pages/merchant-settings/merchant-settings.module"
          ).then((m) => m.MerchantSettingsModule)
      },
      {
        path: "customer-settings",
        loadChildren: () =>
          import(
            "./views/pages/customer-settings/customer-settings.module"
          ).then((m) => m.CustomerSettingsModule)
      },
      {
        path: "isv-settings",
        loadChildren: () =>
          import(
            "./views/pages/isv-settings/isv-settings.module"
          ).then((m) => m.IsvSettingsModule)
      },
      {
        path: "batch-management",
        loadChildren: () =>
          import(
            "./views/pages/batch-management/batch-management.module"
          ).then((m) => m.BatchManagementModule)
      },
      {
        path: "spin-troubleshooting",
        loadChildren: () =>
        import(
          "./views/pages/troubleshooting/troubleshooting.module"
        ).then((m) => m.TroubleshootingModule),
      },
      {
        path: "billing-invoice",
        loadChildren: () =>
        import(
          "./views/pages/billingInvoice/billing-invoice.module"
        ).then((m) => m.BillingInvoiceModule),
        // canActivate: [ModuleGuard],
        // component:BillingInvoiceComponent,
        // data:{module:Modules.BILLING, privilege: Privileges.VIEW_INVOICE}
      },
      {
        path: "advanced",
        loadChildren: () =>
          import(
            "./views/pages/advanced/advanced.module"
          ).then((m) => { return m.AdvancedModule }),
        canActivate: [ModuleGuard],
        data: { module: Modules.ADVANCED },
      },
      // {
        // path: "demo-app",
        // loadChildren: () =>
        // import(
        //   "./views/pages/demo-merchant/demo-merchant.module"
        // ).then((m) => { return m.DemoMerchantModule}),
        // canActivate: [ModuleGuard],
        // component:DemoPaymentOptionsComponent,
        // data:{module:Modules.USER, privilege: Privileges.VIEW_USER}
      // },
      { path: '', redirectTo: 'dashboardv2', pathMatch: 'full' }
      //{ path: "", redirectTo: "transaction-management/transactions", pathMatch: "full" },
      // { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
    ],
  },
  {
    path: "userVerify",
    component: PasswordResetComponent,
  },
  {
    path: "dev",
    loadChildren: () =>
      import(
        "./views/pages/demo-merchant/demo-merchant.module"
      ).then((m) => { return m.DemoMerchantModule}),
  },
  {
    path: "uat",
    loadChildren: () =>
      import(
        "./views/pages/demo-merchant/demo-merchant.module"
      ).then((m) => { return m.DemoMerchantModule}),
  },


  {
    path: "config",
    component: HostedConfigurationComponent,
  },
  {
    path: "error",
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: "Page Not Found",
      desc: "Oopps!! The page you were looking for doesn't exist.",
    },
  },
  {
    path: "message/:data",
    component: MessageComponent
  },
  {
    path: "error/:type",
    component: ErrorPageComponent,
  },
  { path: "**", redirectTo: "error", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
